import { Controller } from "@hotwired/stimulus"
import { requestConfirm, pluralize, fetchWithCsrf, turboFetch } from "../util"

// Connects to data-controller="bulk-actions-panel"
export default class extends Controller {
  static targets = ["counter", "retagButton"]
  static values = {
    tagName: String,
    removeTagUrl: String
  }

  selectedIds = []

  connect() {
    this.handleSelectionChange = this.handleSelectionChange.bind(this)
    document.addEventListener('tableSelection:change', this.handleSelectionChange)
  }

  disconnect() {
    document.removeEventListener('tableSelection:change', this.handleSelectionChange)
  }

  handleSelectionChange(event) {
    const { selectedIds } = event.detail
    this.selectedIds = selectedIds
    this.selectedCount = selectedIds.length
    this.updateCounter(this.selectedCount)
    this.updateRetagButtonUrl()
  }

  updateCounter(count) {
    this.counterTarget.textContent = `${pluralize(count, "item", "items")} selected`
  }

  updateRetagButtonUrl() {
    if (this.hasRetagButtonTarget) {
      const url = new URL(this.retagButtonTarget.href)
      url.searchParams.set('selected_ids', this.selectedIds.join(','))
      this.retagButtonTarget.href = url.toString()
    }
  }

  async delete() {
    const confirmationResult = await requestConfirm({
      modal: "default-confirm",
      data: {
        title: "Confirm Deletion",
        text: `Are you sure you want to delete "${this.tagNameValue}" tag from ${this.selectedCount} items?`
      }
    })

    if (!confirmationResult) return

    try {
      const options = {
        method: 'delete',
        body: JSON.stringify({ selected_ids: this.selectedIds })
      }
      turboFetch(this.removeTagUrlValue, options)
    } catch (error) {
      console.error('Error removing tag:', error)
    }
  }
}
